export const DASHBOARD_HEADER_HEIGHT = 64;
export const DASHBOARD_BODY_PADDING_X = 32;
export const DASHBOARD_BODY_PADDING_Y = 24;
export const DASHBOARD_SIDEBAR_WIDTH = 262;
export const DASHBOARD_MOBILE_NAV_HEIGHT = 75;
